import { Component } from '@angular/core';
import lottie from "lottie-web";
import { defineElement } from '@lordicon/element';
defineElement(lottie.loadAnimation);

@Component({
    selector: 'app-stripe-failure',
    templateUrl: './stripe-failure.component.html',
    standalone: false
})
export class StripeFailureComponent{
    constructor() { 
    }

}